import { NgModule, NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MatProgressSpinnerModule } from '@angular/material';

import { SharedModule } from '../../shared';
import { HomeMaterialModule } from '../home-material/home-material.module';
import { LeaderboardComponent } from './leaderboard.component';
import { LeaderboardChallengeTableComponent } from './leaderboard-challenge-table/leaderboard-challenge-table.component';
import { ColumnsPipe } from '../../shared';
import { SellerRewardsDialogComponent } from '../../shared';
import { LeaderboardSalesTabComponent } from './sales-tab/leaderboard-sales-tab.component';
import { LeaderboardActivityTabComponent } from './activity-tab/leaderboard-activity-tab.component';
import { LeaderboardDistributorComponent } from './activity-tab/distributor/leaderboard-distributor.component';
import { LeaderboardActivityChallengeComponent } from './activity-tab/activity-challenge/leaderboard-activity-challenge.component';
import { LeaderboardCiscoTabComponent } from './cisco-tab/leaderboard-cisco-tab.component';
import { LeaderboardPartnerTabComponent } from './partner-tab/leaderboard-partner-tab.component';
import { LeaderboardChallengeTabComponent } from './challenge-tab/leaderboard-challenge-tab.component';
import { ArchTargetsModalComponent } from './leaderboard-challenge-table/modals/arch-targets-modal/arch-targets-modal.component';
import { TrainingCompletionModalComponent } from './leaderboard-challenge-table/modals/training-completion-modal/training-completion-modal.component';
import { AllTrainingsModalComponent } from './leaderboard-challenge-table/modals/all-trainings-modal/all-trainings-modal.component';
import { ChallengeEntriesComponent } from './leaderboard-challenge-table/entries/challenge-entries.component';
import { ProductBookingAccordionComponent } from './leaderboard-challenge-table/product-booking/product-booking-accordion.component';
import { ChallengeLcdComponent } from './leaderboard-challenge-table/lcd/challenge-lcd.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    SharedModule,
    HomeMaterialModule,
    MatProgressSpinnerModule,
  ],
  declarations: [
    LeaderboardComponent,
    LeaderboardChallengeTableComponent,
    LeaderboardSalesTabComponent,
    LeaderboardActivityTabComponent,
    LeaderboardDistributorComponent,
    LeaderboardActivityChallengeComponent,
    LeaderboardCiscoTabComponent,
    LeaderboardPartnerTabComponent,
    LeaderboardChallengeTabComponent,
    ArchTargetsModalComponent,
    TrainingCompletionModalComponent,
    AllTrainingsModalComponent,
    ChallengeEntriesComponent,
    ProductBookingAccordionComponent,
    ChallengeLcdComponent,
    ColumnsPipe,
  ],
  exports: [
    LeaderboardComponent,
  ],
  entryComponents: [
    SellerRewardsDialogComponent,
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA,
  ],
})
export class LeaderboardModule { }
